import React from 'react';


const BrandName = ({ textAlign = 'center', fontSize = '1.05rem', margin = '0.25rem 0 0.75rem 0' }) => (
  <div style={{
    textAlign,
    color: '#000',
    fontFamily: 'Edensor Free, serif',
    fontSize,
    margin,
    letterSpacing: '0.1em'
  }}>
    m o r i a
  </div>
);

export default BrandName;
